/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';
    import Utils = Common.Utils;

    export interface IGateway extends ITopologyElement, INetworkElement {
        name: string;
        natEnabled: boolean;
        // networkInterfaces: Models.INetworkInterface[];
        hostname: string;
        // defaultGatewayId: number;
        getDisplayLabel: () => string;
        id?: number;
        canWrite?: boolean;
        vnos: Models.Vno[];
        isShared?: boolean;

    }

    export class Gateway implements IGateway {
        public href: string;
        public id: number;
        public name: string;
        public x: number;
        public y: number;
        public natEnabled: boolean;
        public networkInterfaces: Models.INetworkInterface[];
        public hostname: string;
        public defaultGatewayId: number;
        public health: IDataNodeHealth;
        public canWrite: boolean;
        public vnos: Models.Vno[];
        public isShared?: boolean;

        public static Empty(): Gateway {
            return new Gateway();
        }

        public static Copy(gateway: IGateway): Gateway {
            let newGateway: Gateway = new Gateway();
            newGateway.name = gateway.name;
            newGateway.hostname = gateway.hostname;
            newGateway.natEnabled = gateway.natEnabled;
            newGateway.x = gateway.x;
            newGateway.y = gateway.y;
            newGateway.href = gateway.href;
            newGateway.networkInterfaces = gateway.networkInterfaces;
            newGateway.health = gateway.health;
            newGateway.defaultGatewayId = gateway.defaultGatewayId;
            newGateway.vnos = gateway.vnos;
            newGateway.isShared = gateway.isShared;
            return newGateway;
        }

        constructor() {
            // empty constructor
            this.href = '';
            this.id = undefined;
            this.natEnabled = true;
            this.networkInterfaces = undefined;
            this.name = '';
            this.hostname = '';
            this.health = {
                data: {
                    healthStatus: 'PENDING',
                    checks: [],
                    elementId: '',
                },
            };
            this.canWrite = false;
            this.vnos = [];
            this.isShared = undefined;
        }

        public getAvailableInterfaces(): INetworkInterface[] {
            return this.networkInterfaces.filter (
                (nic: INetworkInterface) => {
                    /* tslint:disable */return nic.networkConnectedTo === null;/* tslint:enable */
                }
            );
        }
        
        public isConnectedToNetwork(): boolean {
            return this.networkInterfaces.some (
                (nic: INetworkInterface) => {
                    /* tslint:disable */
                    return nic !== undefined &&
                        nic.networkConnectedTo !== undefined && nic.networkConnectedTo !== null;
                    /* tslint:enable */
                }
            );
        }

        public getDisplayLabel(): string {
            return this.name + (this.hostname ? '\n(' + this.hostname + ')' : '');
        }
        
        public getDisplayImage(): string {
            return 'images/iconmonstr-server-9-240.png';
        }

        // override
        public class(): TopologyElementType {
            return TopologyElementType.Gateway;
        }

        public getVnoNames(): string {
            return this.isShared && this.vnos.length === 1 ? 'shared' : this.vnos.map((vno: Models.Vno) => (vno.name)).join(', ');
        }

        public matchesSearch(search: string): boolean {
            const searchText: string = this.hostname + this.name + this.id + this.getVnoNames();
            const regExp: RegExp = new RegExp(search, "ig");
            return regExp.test( searchText );
        }
    }
}
